// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import { htmlDecode } from '../../_common/api/utility';
import Loading from '../../_common/Loading';
import Card from '../Card';
import { HamQuest } from '../../../App';

const TermsAndConditions = ({ ...props }) => {

    const [TaC, setTaC] = useState(null);
    const [WCTaC, setWCTaC] = useState(null);

    useEffect(() => {
        HamQuest.get(QuestRoute.merchant.terms)
            .then(res => setTaC(htmlDecode(res.terms) || res.terms))

        HamQuest.get(QuestRoute.merchant.WCTerms)
            .then(res => setWCTaC(htmlDecode(res[0].value) || res[0].value))
    }, [])

    if (!TaC) return <Loading />;

    return (
        <>
            <Card title='Terms and Conditions' collapsible>
                <div dangerouslySetInnerHTML={{ __html: TaC }} />
            </Card>
            {WCTaC && (
                <Card title='Wash Club Terms' collapsible>
                    <div dangerouslySetInnerHTML={{ __html: WCTaC }} />
                </Card>
            )}
        </>
    )
}

export default TermsAndConditions;